<template>
  <div>
    <div class="acitve-items" @click="toActivityDetail(content)">
      <div class="active-items-title-read">
        <div class="active-item-title">{{ content.title }}</div>
        <div class="active-itme-read">211阅读</div>
      </div>
      <div class="active-item-pics" v-if="content.pics_url.length>0">
        <img :src="content.pics_url[0]" alt />
      </div>
    </div>
  </div>
</template>

<style scoped>
/* 小图 */
.acitve-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
}
.active-items-title-read {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 58%;
}
.active-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.active-item-pics {
  width: 40%;
}
.active-item-pics img {
  width: 100%;
  height: 1.4rem;
}
.acitve-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
}
.active-itme-read {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
</style>

<script>
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);

export default {
  name: "Activity1",
  components: {},
  props: {
    content: {
      type: Object,
      default: {}
    }
  },

  data: function() {
    return {};
  },

  methods: {
    toActivityDetail(item) {
      let that = this;
      rbLink({
        name:'ActivityDetail',
        query:{
          id: item.id
        }
      });
    }
  },

  filters: {}
};
</script>




// WEBPACK FOOTER //
// Activity1.vue?46421426